module.exports = __webpack_public_path__ + "static/media/master_inactive.e55e4db8.png";